/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { number, object, Schema, string } from '../schema';

export interface AC1Initiateclientcredentialsgrant {
  tokenType: string;
  expiresIn: number;
  accessToken: string;
}

export const aC1InitiateclientcredentialsgrantSchema: Schema<AC1Initiateclientcredentialsgrant> = object(
  {
    tokenType: ['token_type', string()],
    expiresIn: ['expires_in', number()],
    accessToken: ['access_token', string()],
  }
);
